import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import DashboardHeader from '../components/DashboardHeader';
import ProfileCompletionBanner from '../components/ProfileCompletionBanner';
import { Breadcrumbs } from '../components/common/Breadcrumbs';
import { GlobalChatFab } from '../components/messaging/GlobalChatFab';

/** Layout Expéditeur/Client (sidebar standard + breadcrumbs + profile banner). */
export const DashboardLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('client_sidebar_collapsed_v2') === '1');

  // Sync avec changement dans Sidebar (via storage event ou polling léger)
  useEffect(() => {
    const id = setInterval(() => {
      const v = localStorage.getItem('client_sidebar_collapsed_v2') === '1';
      if (v !== collapsed) setCollapsed(v);
    }, 250);
    return () => clearInterval(id);
  }, [collapsed]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
      <div className={`transition-all duration-300 ${collapsed ? 'lg:ml-16' : 'lg:ml-64'}`}>
        <DashboardHeader onMenuClick={() => setMobileOpen(true)} />
        <main className="pt-16 sm:pt-20 p-3 sm:p-6">
          <Breadcrumbs />
          <ProfileCompletionBanner />
          {children}
        </main>
      </div>
      <GlobalChatFab />
    </div>
  );
};
